import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FormattedMessage } from 'react-intl';

function DeleteCategoryValidationDialog({ open, category, onCancel, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <FormattedMessage id="editableCollectionWithCategories.deleteCategoryTitle" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <FormattedMessage
            id="editableCollectionWithCategories.deleteCategoryDescription"
            values={{
              categoryName: <b>{category.category}</b>
            }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button id="cancel-dialog" onClick={onCancel} color="primary">
          <FormattedMessage id="global.cancel" />
        </Button>
        <Button id="confirm-dialog" onClick={onConfirm} color="primary" autoFocus>
          <FormattedMessage id="global.delete" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DeleteCategoryValidationDialog.defaultProps = {
  category: {}
};

DeleteCategoryValidationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  category: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default DeleteCategoryValidationDialog;
